import { MINIMIZE_CALLING_WIDGET } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function minimizeCallingWidget(shouldMinimize) {
  return callingAPIMethodWithQueue(MINIMIZE_CALLING_WIDGET, shouldMinimize);
}